import React, { useEffect, useState } from "react";
//Css Here
import { getPlayedRaffles } from "@network/Raffle";
import { Raffle, RaffleDataBased } from "@type/Raffle";

//Css Here
import { SCREEN } from "@type/index";
import RaffleSwiperRender from "../Dashboard/Components/RaffleSwipeRender";
// import * as S from "./style";
// import useDataSideBar from "src/hooks/useDataSideBar";
// import { useFetchImages } from "src/Layouts/DashboardLayout/DashboardPreview";
// import useThemeInitializer from "src/ThemeInitializer";
// import DashboardConstant from "@views/Pages/Dashboard/landing-image.constant";
import HeroRaffle from "@components/DashboardBox/HeroRaffle";

// interface PlayedRaffleData {
//     raffles: (Raffle & {
//         lastPlayedTime: Date;
//         timesPlayed: number;
//     })[];
// }

const PlayedRaffles: React.FC = () => {
    const [playedRaffleData, setPlayedRaffleData] = useState<RaffleDataBased>();
    // const [navbar, setNavbar] = useState(false);
    const [loading, setLoading] = useState(true);
    const limit = 10;
    // const { DataSideDashboardBar } = useDataSideBar();
    // const images = useFetchImages();
    // const { fetchTheme, theme } = useThemeInitializer();
    useEffect(() => {
        fetchPlayedRaffles();
    }, []);

    const fetchPlayedRaffles = async () => {
        const data = {
            limit: limit,
            offset: 0,
            type: "ALL",
            screen: SCREEN.PLAYED_RAFFLES,
        };
        try {
            setLoading(true);
            const response = await getPlayedRaffles(data);
            const convertedData = convertToRaffleData(response.data);
            console.log("converted data", convertedData)
            setPlayedRaffleData(convertedData);
        } catch (error) {
            console.error("Error fetching played raffles:", error);
        } finally {
            setLoading(false);
        }
    };

    // const changeBackGround = () => {
    //     if (window.scrollY > 20) {
    //         setNavbar(true);
    //     } else setNavbar(false);
    // };
    // window.addEventListener("scroll", changeBackGround);

    // Convert played raffles data to the format expected by RaffleSwiperRender
    const convertToRaffleData = (playedData: any | undefined) => {
        console.log("convertToRaffleData - playedData:", playedData);
        if (!playedData || !playedData.raffles || playedData.raffles.length === 0) {
            return undefined;
        }

        // Map through raffles and include nextRaffleDrawId details if available
        const rafflesWithNextDraw = playedData.raffles.map((raffle: any) => {
            // const nextRaffleDraw = raffle.nextRaffleDrawId
            //     ? {
            //         id: raffle.nextRaffleDrawId.id,
            //         dateTime: raffle.nextRaffleDrawId.dateTime,
            //         status: raffle.nextRaffleDrawId.status,
            //     }
            //     : null;

            return {
                ...raffle,
                id: raffle?.nextRaffleDrawId?.id,
                dateTime: raffle?.nextRaffleDrawId?.dateTime,
                status: raffle?.nextRaffleDrawId?.status,
            };
        });

        // Create an empty raffle object that matches the Raffle type
        const emptyRaffle: Raffle = {
            id: 0,
            raffleId: 0,
            title: '',
            type: 'DAILY',
            status: 'WAITING_PEOPLE',
            startTime: new Date(),
            expiredDate: new Date(),
            category: '',
            numberOfTurns: 0,
            numberOfParticipants: 0,
            thumbnailImg: '',
            bannerImg: '',
            rn: '',
            favorite: false,
            color: {},
        };

        const dailyRaffles = rafflesWithNextDraw.filter((r: Raffle) => r.type === 'DAILY');
        const weeklyRaffles = rafflesWithNextDraw.filter((r: Raffle) => r.type === 'WEEKLY');
        const monthlyRaffles = rafflesWithNextDraw.filter((r: Raffle) => r.type === 'MONTHLY');
        const quarterlyRaffles = rafflesWithNextDraw.filter((r: Raffle) => r.type === 'QUARTERLY');
        const halfYearRaffles = rafflesWithNextDraw.filter((r: Raffle) => r.type === 'HALF_YEAR');
        const annuallyRaffles = rafflesWithNextDraw.filter((r: Raffle) => r.type === 'ANNUALLY');
        const specialRaffles = rafflesWithNextDraw.filter((r: Raffle) => r.type === 'SPECIAL');

        return {
            raffles: {
                nextRaffle: emptyRaffle,
                daily: { raffles: dailyRaffles, total: dailyRaffles.length },
                weekly: { raffles: weeklyRaffles, total: weeklyRaffles.length },
                monthly: { raffles: monthlyRaffles, total: monthlyRaffles.length },
                quarterly: { raffles: quarterlyRaffles, total: quarterlyRaffles.length },
                halfYear: { raffles: halfYearRaffles, total: halfYearRaffles.length },
                annually: { raffles: annuallyRaffles, total: annuallyRaffles.length },
                special: { raffles: specialRaffles, total: specialRaffles.length },
            },
        };
    };

    return (
        <>
            <HeroRaffle
                title="My Raffles"
                subtitle="Check all your raffles from here"
            />
            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <p>Loading your played raffles...</p>
                </div>
            ) : (
                <div className="p-10">
                    <RaffleSwiperRender
                        raffleData={playedRaffleData}
                        screen={SCREEN.PLAYED_RAFFLES}
                        skipFirstItem={false}
                    />
                </div>
            )}
            {/* <div className="dabour-dashboard-header">
                <div className="mobile-hidden">
                    <HeaderBar />
                </div>
                <div>
                    <S.ContainerNavigate className={navbar ? "activeBg" : ""}>
                        <Navigate />
                     <BreadcrumbNav /> 
                    </S.ContainerNavigate>
                </div>
                <div className="my-raffle">
                    <Sidebar sideData={DataSideDashboardBar} />
                    <div className="main-body-dashboard-right" >
                        <S.RaffleContainer>

                            <div className="hero-section mobile-hidden">
                                <S.playedrafflesHeroSectionContainer>
                                    <div>
                                        <S.HeroTitle>
                                            My Raffles{" "}
                                            <span style={{ display: "inline-block", verticalAlign: "middle", position: "absolute", top: "-25px" }}>
                                                <svg width="40" height="40" viewBox="0 0 29 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.3732 1.3103C20.7736 12.8828 12.6052 23.8117 6.38251 26.1235C0.311292 15.4682 1.59842 9.57634 11.3732 1.3103Z" fill="#52B12F" />
                                                    <path d="M11.3735 1.31036C1.59865 9.5764 0.311525 15.4682 6.38274 26.1236L11.3735 1.31036Z" fill="#1B5C29" />
                                                    <path d="M27.7285 24.0862C22.6969 33.5442 13.179 31.1932 9.90891 27.7206C15.2643 20.7228 19.524 19.9274 27.7285 24.0862Z" fill="#52B12F" />
                                                    <path d="M27.7285 24.0864C19.5241 19.9276 15.2643 20.723 9.90894 27.7208L27.7285 24.0864Z" fill="#1B5C29" />
                                                </svg>

                                            </span>
                                        </S.HeroTitle>

                                        <S.Subtitle>Check all your raffles from here</S.Subtitle>
                                    </div>

                                </S.playedrafflesHeroSectionContainer>
                            </div>
                            {loading ? (
                                <div style={{ textAlign: 'center', padding: '50px' }}>
                                    <p>Loading your played raffles...</p>
                                </div>
                            ) : (
                                <div className="raffle-details-data">
                                    <RaffleSwiperRender
                                        raffleData={playedRaffleData}
                                        screen={SCREEN.PLAYED_RAFFLES}
                                        skipFirstItem={false}
                                    />
                                </div>
                            )}
                        </S.RaffleContainer>
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default PlayedRaffles;